var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"limit-txt-wrapper"},[_c('RichText',{attrs:{"text":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }